import { render, staticRenderFns } from "./ResolutionCard.vue?vue&type=template&id=a8b3b0f2"
import script from "./ResolutionCard.vue?vue&type=script&lang=js"
export * from "./ResolutionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports